import { render, staticRenderFns } from "./TaskDetailTemplate.vue?vue&type=template&id=2a433034&"
import script from "./TaskDetailTemplate.vue?vue&type=script&lang=tsx&"
export * from "./TaskDetailTemplate.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports